module.exports = __webpack_public_path__ + "static/media/White Hart A4 Children & Vegan Menu.ee13ef09.pdf";